import JSBridge from './jsbridge'
import UniUtils from '@/utils/uni'
const pageBack = function () {
  if (window.mobileRuntime.isApp) {
    JSBridge.callHandler("onBackPressed");
  } else if (window.mobileRuntime.isMiniProgram) {
    UniUtils.miniPageBack()
  } else {
    window.history.go(-1)
  }
}

export default {
  pageBack
}
